import { mailStore } from 'owa-mail-store';
import { getIsBitSet } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
import { now } from 'owa-datetime/lib/displaydate/now';
import { initializeTimeGroupHeaders } from 'owa-mail-group-headers';
import { action } from 'satcheljs/lib/legacy';
/**
 * Updates todayDate in the store
 */
export default action('updateTodayDate')(function updateTodayDate() {
    var nowDate = now();
    var todayDate = new Date(nowDate);
    todayDate.setHours(0, 0, 0, 0);
    mailStore.todayDate = todayDate;
    // Initialize time group ranges if date headers are enabled
    if (!getIsBitSet(2 /* DateHeadersDisabled */)) {
        initializeTimeGroupHeaders(nowDate);
    }
});
//# sourceMappingURL=updateTodayDate.js.map